<template>
  <div class="wrapper">
    <div class="row">
      <div class="col-lg-12">
        <div id="filters">
          <div class="search col-lg-12 col-md-12">
            <div class="row">
              <div class="col-lg-3 col-md-3 m-t-sm">
                <v-select
                  placeholder="Clients"
                  :options="f.clients"
                  label="name"
                  multiple
                  v-model="multiFilters['clients']"
                ></v-select>
              </div>
              <div class="col-lg-3 col-md-3 m-t-sm">
                <v-select
                  placeholder="Issue"
                  :options="issueTypes"
                  multiple
                  v-model="multiFilters['issueType']"
                >
                </v-select>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-3 m-t-sm">
            <button class="btn btn-xs btn-primary" @click="loadIssues">Search</button>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <table class="hover table">
          <thead>
          <tr>
            <th>Domain</th>
            <th>Client</th>
            <th>Date</th>
            <th>
              Issues
              <i class="fa fa-refresh pull-right" style="cursor: pointer" @click="loadIssues"></i>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="site in issues" :key="site.id">
            <td>
              <router-link :to="'/pbn/' + site.punyDomain">{{ site.domain }}</router-link>
            </td>
            <td>{{ site.client.name }}</td>
            <td>{{ $moment(site.qaCheck.time.date).format('DD.MM. HH:mm') }}</td>
            <td>
              <div class="row m-b-sm" v-for="(check, i) in site.qaCheck.failedChecks" :key="'check - ' + i">
                <hr v-if="i > 0" class="m-t-xs m-b-xs">
                <span :title="check"><i class="fa fa-warning red"></i> {{ shorten(check, 180) }}</span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { Values, Query } from '../../../../mixins/helperMixin'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      issues: [],
      multiFilters: [],
      issueTypes: [
        {label: 'Tech Issue', id: 'tech'},
        {label: 'Content', id: 'content'},
        {label: 'Settings', id: 'settings'}
      ]
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  mixins: [
    Values, Query
  ],
  mounted () {
    document.title = 'Issues :: Reports :: PBN360 by Aphex Media'
    this.loadIssues()
  },
  methods: {
    loadIssues () {
      axios.get('/pbn/qa/issues?' + this.buildQuery({}, this.multiFilters)).then(r => {
        this.issues = r.data.data
      }).catch(e => {
        this.$toastr.error(e, 'No issues for you')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Reports/Issues.vue